import React from 'react';
import { useIntl } from 'react-intl-next';
import { Text } from '@atlaskit/primitives/compiled';
import { IntlQuestionTypeMessages } from '../../../../jira-common';
import { questionTypeToQuestionTypeMessage } from '../../../utils';
import { messages } from './messages';
import { UnknownQuestionTypeText } from './styled';
export function UnknownQuestionType(_ref) {
  var questionType = _ref.questionType;
  var intl = useIntl();
  var questionTypeMessage = IntlQuestionTypeMessages[questionTypeToQuestionTypeMessage(questionType)];
  return /*#__PURE__*/React.createElement(UnknownQuestionTypeText, {
    "data-testid": "proforma-unknown-question"
  }, intl.formatMessage(messages.unknownQuestionType, {
    questionType: questionTypeMessage ? intl.formatMessage(questionTypeMessage) : '',
    // Cannot rely on ProformaIntlProvider for this since this could be rendered inside the editor (which prevents accesses from providers outside)
    strong: function strong(chunks) {
      return /*#__PURE__*/React.createElement(Text, {
        as: "strong"
      }, chunks);
    }
  }));
}